import Image from 'next/image'
import Link from 'next/link'
import { Button } from '@/components/ui/button'

const RegisterPro = () => {
  return (
    <div className="flex flex-col space-y-8 items-center container">
      <Image
        src="/images/for-pro/v2/register.png"
        alt=""
        width={240}
        height={240}
      />
      <div>
        <h2 className="text-2xl lg:text-3xl font-bold text-center mb-3">
          さあ、あなたの音楽で誰かの夢を形にしよう。
        </h2>
        <p className="text-center text-base sm:text-xl font-semibold text-ghost">あなたを必要とするクライアントが、今日も待っています。</p>
      </div>
      <div className="flex justify-center">
        <Button variant="primary" size="xl" asChild className="w-72">
          <Link href="/register-pro">
            まずは登録してみる
          </Link>
        </Button>
      </div>
    </div>
  )
}

export default RegisterPro
